<template>
  <div class="bg-white">
    <div class="card-body pb-15 px-4">
      <!-- Documentación -->
      <div v-if="showDocumentacionForm">
        <div class="row g-4">
          <!-- Nacionalidad -->
          <div v-if="viaje.formularioInscripcion.checkIn.nacionalidadEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.nacionalidad') }}</label>
            <InputSelector
              v-model="formularioData.formDataDocumentacion.nacionalidad"
              :options="countryList"
              :placeholder="$t('reserva.checkIn.placeholders.seleccionaNacionalidad')"
              :disabled="!formulario.checkInPendiente" />
          </div>

          <!-- Fecha Nacimiento -->
          <div v-if="viaje.formularioInscripcion.checkIn.fechaNacimientoEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.fechaNacimiento') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.fechaNacimiento"
              type="date"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              :placeholder="$t('reserva.checkIn.placeholders.fecha')"
              @keydown.prevent />
          </div>

          <!-- Lugar Nacimiento -->
          <div v-if="viaje.formularioInscripcion.checkIn.lugarNacimientoEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.lugarNacimiento') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.lugarNacimiento"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
          </div>

          <!-- tipoDocumento -->
          <div v-if="viaje.formularioInscripcion.checkIn.tipoDocumentoEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.tipoDocumento') }}</label>
            <InputSelector
              v-model="formularioData.formDataDocumentacion.tipoDocumento"
              :options="tiposDocumentoOptions"
              :placeholder="$t('reserva.checkIn.placeholders.seleccionaTipoDocumento')"
              :disabled="!formulario.checkInPendiente" />
          </div>

          <!-- DNI/Pasaporte -->
          <div v-if="viaje.formularioInscripcion.checkIn.dniEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.dni') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.dni"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              placeholder="AAA000000" />
          </div>

          <!-- numSoporte -->
          <div v-if="viaje.formularioInscripcion.checkIn.numSoporteEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.numSoporte') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.numSoporte"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
          </div>

          <!-- Fecha Caducidad -->
          <div v-if="viaje.formularioInscripcion.checkIn.fechaCaducidadEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.fechaCaducidad') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.fechaCaducidadDni"
              type="date"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              placeholder="dd/mm/aa"
              @keydown.prevent />
          </div>

          <!-- Fecha Expedición -->
          <div v-if="viaje.formularioInscripcion.checkIn.fechaExpedicionEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.fechaExpedicion') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.fechaExpedicionDni"
              type="date"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              placeholder="dd/mm/aa"
              @keydown.prevent />
          </div>

          <!-- Pais -->
          <div v-if="viaje.formularioInscripcion.checkIn.paisEnabled" class="col-12">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.pais') }}</label>
            <InputSelector
              v-model="formularioData.formDataDocumentacion.pais"
              :options="countryList"
              :placeholder="$t('reserva.checkIn.placeholders.seleccionaPais')"
              :disabled="!formulario.checkInPendiente" />
          </div>

          <!-- Provincia -->
          <div v-if="viaje.formularioInscripcion.checkIn.provinciaEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.provincia') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.provincia"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
          </div>

          <!-- Poblacion -->
          <div v-if="viaje.formularioInscripcion.checkIn.poblacionEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.poblacion') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.poblacion"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
          </div>

          <!-- Direccion -->
          <div v-if="viaje.formularioInscripcion.checkIn.domicilioEnabled" class="col-12 col-md-8">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.direccion') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.direccion"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
          </div>

          <!-- Codigo Postal -->
          <div v-if="viaje.formularioInscripcion.checkIn.codPostalEnabled" class="col-12 col-md-4">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.codigoPostal') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.codigoPostal"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
          </div>

          <div
            v-if="viaje.formularioInscripcion.checkIn.anversoDniEnabled && !formulario?.checkIn.dniSubido"
            class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.anversoDni') }}</label>
            <div class="file-input-wrapper">
              <button
                v-if="!formularioData.formDataDocumentacion.anversoDni"
                class="file-input-button"
                @click="anversoDniInput.click()">
                <span>{{ $t('reserva.checkIn.seleccionarDocumento') }}</span>
                <UploadIcon class="ms-1" />
              </button>
              <button
                v-if="formularioData.formDataDocumentacion.anversoDni"
                class="file-input-button"
                @click="fileDeletedHandler('anversoDni', anversoDniInput)">
                <span>{{ formularioData.formDataDocumentacion.anversoDni.name }}</span>
                <i class="fas fa-trash"></i>
              </button>
              <input
                ref="anversoDniInput"
                type="file"
                accept="image/jpeg, image/png"
                class="d-none"
                :disabled="!formulario.checkInPendiente"
                @change="fileChangeHandler($event, 'anversoDni')" />
            </div>
          </div>

          <!-- Reverso DNI -->
          <div
            v-if="viaje.formularioInscripcion.checkIn.reversoDniEnabled && !formulario?.checkIn.dniSubido"
            class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.reversoDni') }}</label>
            <div class="file-input-wrapper">
              <button
                v-if="!formularioData.formDataDocumentacion.reversoDni"
                class="file-input-button"
                @click="reversoDniInput.click()">
                <span>{{ $t('reserva.checkIn.seleccionarDocumento') }}</span>
                <UploadIcon class="ms-1" />
              </button>
              <button
                v-if="formularioData.formDataDocumentacion.reversoDni"
                class="file-input-button"
                @click="fileDeletedHandler('reversoDni', reversoDniInput)">
                <span>{{ formularioData.formDataDocumentacion.reversoDni.name }}</span>
                <i class="fas fa-trash"></i>
              </button>
              <input
                ref="reversoDniInput"
                type="file"
                accept="image/jpeg, image/png"
                class="d-none"
                :disabled="!formulario.checkInPendiente"
                @change="fileChangeHandler($event, 'reversoDni')" />
            </div>
          </div>

          <!-- Sexo -->
          <div v-if="viaje.formularioInscripcion.checkIn.sexoEnabled" class="col-12">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.sexo.title') }}</label>
            <div class="d-flex flex-column gap-2">
              <div class="form-check">
                <input
                  :id="'sexo-hombre' + formularioData.id"
                  v-model="formularioData.formDataDocumentacion.sexo"
                  class="form-check-input"
                  type="radio"
                  value="hombre"
                  :disabled="!formulario.checkInPendiente" />
                <label class="form-check-label" :for="'sexo-hombre' + formularioData.id">
                  {{ $t('reserva.checkIn.sexo.hombre') }}
                </label>
              </div>
              <div class="form-check">
                <input
                  :id="'sexo-mujer' + formularioData.id"
                  v-model="formularioData.formDataDocumentacion.sexo"
                  class="form-check-input"
                  type="radio"
                  value="mujer"
                  :disabled="!formulario.checkInPendiente" />
                <label class="form-check-label" :for="'sexo-mujer' + formularioData.id">
                  {{ $t('reserva.checkIn.sexo.mujer') }}
                </label>
              </div>
            </div>
          </div>

          <!-- Llegada -->
          <div v-if="viaje.formularioInscripcion.checkIn.llegadaEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.llegada') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.horaCheckIn"
              type="datetime-local"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              @change="completeDatetime('horaCheckIn')"
              @keydown.prevent />
          </div>

          <!-- Salida -->
          <div v-if="viaje.formularioInscripcion.checkIn.salidaEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.salida') }}</label>
            <input
              v-model="formularioData.formDataDocumentacion.horaCheckOut"
              type="datetime-local"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.checkInPendiente"
              @change="completeDatetime('horaCheckOut')"
              @keydown.prevent />
          </div>
        </div>
      </div>

      <!-- Datos Personales -->
      <div v-if="showPersonalForm" class="mt-4">
        <div class="row g-4">
          <!-- Alergias -->
          <div v-if="viaje.formularioInscripcion.datosPersonales.alergiasEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.alergias') }}</label>
            <input
              v-model="formularioData.formDataPersonal.alergias"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.datosPersonalesPendiente"
              :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
          </div>

          <!-- Altura -->
          <div v-if="viaje.formularioInscripcion.datosPersonales.alturaEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.altura') }}</label>
            <input
              v-model="formularioData.formDataPersonal.altura"
              type="number"
              step="any"
              min="0"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.datosPersonalesPendiente"
              :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
          </div>

          <!-- Peso -->
          <div v-if="viaje.formularioInscripcion.datosPersonales.pesoEnabled" class="col-12 col-md-6">
            <div class="col-12 col-md-6">
              <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.peso') }}</label>
              <div class="input-group">
                <input
                  v-model="formularioData.formDataPersonal.peso"
                  type="number"
                  step="any"
                  min="0"
                  class="form-control bg-light border-0 py-3"
                  :disabled="!formulario.datosPersonalesPendiente"
                  placeholder="0" />
                <span class="input-group-text bg-light border-0">Kg</span>
              </div>
            </div>
          </div>

          <!-- Talla de pie -->
          <div v-if="viaje.formularioInscripcion.datosPersonales.tallaPieEnabled" class="col-12 col-md-6">
            <label class="form-label text-primary small mb-2">{{ $t('reserva.checkIn.tallaPie') }}</label>
            <input
              v-model="formularioData.formDataPersonal.tallaPie"
              type="number"
              step="any"
              min="0"
              class="form-control bg-light border-0 py-3"
              :disabled="!formulario.datosPersonalesPendiente"
              :placeholder="$t('reserva.checkIn.placeholders.escribeTuRespuesta')" />
          </div>
        </div>
      </div>

      <!-- Preguntas -->
      <div v-if="showPreguntas" class="mt-4">
        <div v-for="pregunta in viaje.formularioInscripcion.preguntas" :key="pregunta.id" class="pregunta-input">
          <div class="col-12 mb-4 text-primary input-container">
            <label class="label-input translate" :for="`pregunta_${pregunta.id}`">
              {{ pregunta.pregunta }}
            </label>
            <input
              v-model="formularioData.formDataPreguntas.preguntas.find(item => item.id === pregunta.id).respuesta"
              class="form-control text-start"
              :name="`pregunta_${pregunta.id}`"
              :placeholder="t('subtitulo.escribeRespuesta')"
              type="text"
              :disabled="!formulario.preguntasPendiente" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, reactive, watch, onBeforeMount, computed } from 'vue';
  import countries from 'i18n-iso-countries';
  import enLocale from 'i18n-iso-countries/langs/en.json';
  import esLocale from 'i18n-iso-countries/langs/es.json';
  import frLocale from 'i18n-iso-countries/langs/fr.json';
  import itLocale from 'i18n-iso-countries/langs/it.json';
  import Cookies from 'js-cookie';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import debounce from 'lodash/debounce';
  import { cloneDeep } from 'lodash';
  import { useI18n } from 'vue-i18n';
  import UploadIcon from '@/components/Icons/UploadIcon.vue';
  import { comprimirImagen } from '@/helpers/imageHelpers';
  import { createToaster } from '@meforma/vue-toaster';
  import { TIPOS_DOCUMENTO } from '@/constants/usuarioConstants';
  import InputSelector from '@/components/inputs/InputSelector.vue';

  const props = defineProps({
    formulario: {
      type: Object, //RReservaDatosFormularioInscripcionDTO
      required: true,
    },
    instant: {
      type: Boolean,
      default: false,
    },
  });

  const emits = defineEmits(['updateFormulario']);
  const { t } = useI18n();
  const toaster = createToaster({ position: 'top-right' });

  const storeHabitacion = informacionHabitacion();
  const viaje = storeHabitacion.getViaje;
  const countryList = ref({});
  const anversoDniInput = ref(null);
  const reversoDniInput = ref(null);

  const tiposDocumentoList = computed(() => [
    {
      id: TIPOS_DOCUMENTO.DNI,
      nombre: t('reserva.checkIn.tiposDocumento.' + TIPOS_DOCUMENTO.DNI),
    },
    {
      id: TIPOS_DOCUMENTO.PASAPORTE,
      nombre: t('reserva.checkIn.tiposDocumento.' + TIPOS_DOCUMENTO.PASAPORTE),
    },
  ]);

  const tiposDocumentoOptions = computed(() => {
    return tiposDocumentoList.value.reduce((acc, tipo) => {
      acc[tipo.id] = tipo.nombre;
      return acc;
    }, {});
  });

  const showDocumentacionForm = computed(
    () => viaje.formularioInscripcion.checkInEnabled && (!props.instant || viaje.formularioInscripcion.checkInInstant)
  );

  const showPersonalForm = computed(
    () =>
      viaje.formularioInscripcion.datosPersonalesEnabled &&
      (!props.instant || viaje.formularioInscripcion.datosPersonalesInstant)
  );
  const showPreguntas = computed(
    () =>
      viaje.formularioInscripcion.preguntasEnabled &&
      viaje.formularioInscripcion.preguntas &&
      viaje.formularioInscripcion.preguntas.length > 0
  );

  const showFormulario = computed(() => showDocumentacionForm.value || showPersonalForm.value || showPreguntas.value);

  const formularioData = reactive({
    id: props.formulario?.id,
    nombre: props.formulario?.checkIn.nombre,
    showed: showFormulario.value,
    checkInPendiente: props.formulario?.checkInPendiente,
    checkInEnabled: viaje.formularioInscripcion.checkInEnabled,
    checkInInstant: viaje.formularioInscripcion.checkInInstant,
    checkIn: viaje.formularioInscripcion.checkIn,
    dniSubido: props.formulario?.checkIn.dniSubido,
    datosPersonalesPendiente: props.formulario?.datosPersonalesPendiente,
    datosPersonalesEnabled: viaje.formularioInscripcion.datosPersonalesEnabled,
    datosPersonalesInstant: viaje.formularioInscripcion.datosPersonalesInstant,
    datosPersonales: viaje.formularioInscripcion.datosPersonales,
    preguntasEnabled: viaje.formularioInscripcion.preguntasEnabled,
    preguntasPendiente: props.formulario?.preguntasPendiente,
    formDataDocumentacion: {
      nombre: props.formulario?.checkIn.nombre || null,
      apellidos: props.formulario?.checkIn.apellidos || null,
      nacionalidad: props.formulario?.checkIn.nacionalidad ?? null,
      fechaNacimiento: props.formulario?.checkIn.fechaNacimiento || null,
      lugarNacimiento: props.formulario?.checkIn.lugarNacimiento || null,
      tipoDocumento: props.formulario?.checkIn?.tipoDocumento?.id ?? null,
      dni: props.formulario?.checkIn.dni || null,
      numSoporte: props.formulario?.checkIn.numSoporte || null,
      fechaCaducidadDni: props.formulario?.checkIn.fechaCaducidadDni || null,
      fechaExpedicionDni: props.formulario?.checkIn.fechaExpedicionDni || null,
      pais: props.formulario?.checkIn.pais ?? null,
      provincia: props.formulario?.checkIn.provincia || null,
      poblacion: props.formulario?.checkIn.poblacion || null,
      direccion: props.formulario?.checkIn.direccion || null,
      codigoPostal: props.formulario?.checkIn.codigoPostal || null,
      sexo: props.formulario?.checkIn.sexo || null,
      horaCheckIn: props.formulario?.checkIn.horaCheckIn || null,
      horaCheckOut: props.formulario?.checkIn.horaCheckOut || null,
      anversoDni: props.formulario?.checkIn.anversoDni || null,
      reversoDni: props.formulario?.checkIn.reversoDni || null,
    },
    formDataPersonal: {
      alergias: props.formulario?.datosPersonales.alergias || null,
      altura: props.formulario?.datosPersonales.altura || null,
      peso: props.formulario?.datosPersonales.peso || null,
      tallaPie: props.formulario?.datosPersonales.tallaPie || null,
    },
    formDataPreguntas: {
      preguntas:
        viaje.formularioInscripcion.preguntas?.map(pregunta => {
          const preguntaExistente = props.formulario?.preguntas?.preguntas?.find(p => p.id === pregunta.id);
          return {
            id: pregunta.id,
            respuesta: preguntaExistente?.respuesta ?? null,
          };
        }) || [],
    },
  });

  function completeDatetime(field) {
    if (formularioData.formDataDocumentacion[field] !== null) {
      formularioData.formDataDocumentacion[field] += ':00';
    }
  }

  async function fileChangeHandler(event, field) {
    const file = event.target.files[0];
    const compressedFile = await comprimirImagen(file, 40);
    if (compressedFile.size > 2097152) {
      toaster.error(`${t('home.form.tamañoMaximo')} 2mb`);
      event.target.value = null;
      return;
    }
    if (compressedFile) {
      formularioData.formDataDocumentacion[field] = new File([compressedFile], file.name, {
        type: file.type,
        lastModified: Date.now(),
      });
    }
  }

  function fileDeletedHandler(field, input) {
    formularioData.formDataDocumentacion[field] = null;
    input.value = null;
  }

  watch(
    formularioData,
    debounce(newValue => {
      emits('updateFormulario', cloneDeep(newValue));
    }, 500)
  );

  onBeforeMount(() => {
    countries.registerLocale(esLocale);
    countries.registerLocale(enLocale);
    countries.registerLocale(frLocale);
    countries.registerLocale(itLocale);
    countryList.value = Object.entries(countries.getNames(Cookies.get('lang')))
      .sort(([, a], [, b]) => a.localeCompare(b))
      .reduce((sorted, [code, name]) => {
        sorted[code] = name;
        return sorted;
      }, {});
    emits('updateFormulario', cloneDeep(formularioData));
  });
</script>

<style lang="scss" scoped>
  @import '~@/assets/scss/main.scss';

  .input-container {
    .label-input {
      margin-bottom: 0.5rem;
      font-size: 16px;
      font-weight: 500;

      @include media-breakpoint-down(md) {
        font-size: 13px;
      }
    }

    &.input-error {
      .label-input {
        color: #dc3545;
      }

      .form-control,
      .form-select-validate {
        border: solid 2px #dc3545;

        &:focus {
          outline: 0;
          box-shadow: 0 0 0 0.25rem rgba(255, 10, 30, 0.25);
        }
      }
    }
  }
  .form-label {
    font-weight: 500;
    font-size: 16px;
  }

  .card-resumen {
    border-radius: var(--bs-border-radius-xl);
    border: 1px solid rgba(33, 36, 68, 0.25);

    .card-body {
      padding: 1rem 2rem;
    }
  }

  .title-name {
    font-size: 20px;
    font-weight: 600;
    color: #212444;
  }

  .container {
    max-width: 100%;
    width: 100%;
    margin: 0 auto;
    padding: 20px;
  }

  .btn-upload {
    padding: 8px 16px;
    background-color: #f0f0f0;
    border: 1px solid #212444;
    border-radius: 4px;
    cursor: pointer;
    color: #333;
  }

  .radio-group {
    display: flex;
    gap: 20px;
  }

  .radio-group label {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .datetime-group {
    display: flex;
    gap: 10px;
  }

  .datetime-group input {
    flex: 1;
  }

  .radio-options {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .radio-option {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .radio-circle {
    flex: 0 0 auto;
  }

  .radio-circle input[type='radio'] {
    margin: 0;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  .radio-option span {
    color: #212444;
    font-size: 0.9rem;
  }

  .conditional-input {
    margin: 0.5rem 0 0.5rem 20px;
    width: calc(100% - 20px);
  }

  .conditional-input input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    background-color: #f8f8f8;
  }

  .file-input-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  .file-input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
  }

  .file-input-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    border: 1px solid var(--bs-primary);
    border-radius: 25px;
    background: white;
    color: var(--bs-primary);
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease;

    span {
      color: var(--bs-primary);
    }

    i,
    :deep(svg) {
      color: var(--bs-primary);
      margin-left: 10px;
    }

    &:hover {
      background-color: rgba(var(--bs-primary-rgb), 0.05);
    }
  }

  .form-control,
  .form-select {
    background-color: rgba(32, 36, 68, 0.02) !important;
    box-shadow: 0 0 3px 0 rgba(32, 36, 68, 0.35) inset !important;
    border: none !important;
    height: 40px !important;
    padding: 0.375rem 0.75rem !important;
    text-align: left !important;
  }

  .form-check {
    .form-check-input[type='radio'] {
      cursor: pointer;
      border: 1px solid rgba(var(--bs-primary-rgb), 0.3);

      &:checked {
        background-color: var(--bs-secondary);
        border-color: var(--bs-primary);
      }

      &:focus {
        box-shadow: none;
      }
    }
  }

  :deep(.tooltip-left) {
    width: 10vw;

    @media (max-width: 768px) {
      font-size: 11px;
    }
  }

  .form-control,
  .form-select {
    &:disabled {
      background-color: white !important;
      opacity: 0.7 !important;
    }
  }

  @media screen and (max-width: 768px) {
    .form-label,
    .form-control,
    .form-select,
    .form-check-label,
    input::placeholder,
    select,
    .input-group-text {
      font-size: 13px !important;
    }
  }
</style>
